export default __webpack_public_path__ + "static/added-64f90fe4d4685f9175eaad1e0b1f254c.png";